// @flow

import React from 'react'
import type { Node } from 'react'
import { navigate } from 'gatsby'
import { Formik, useFormikContext } from 'formik'

import { netlifyFormsEncode } from './netlify-forms-helpers'
import { PureContactForm } from './contact-pure-contact-form'
import { ContactSchema } from './contact-validation-schema'
import { contactContent } from './contact-content'
import type { FormData } from '../../types'

type ContactFormProps = {
  formName: string,
}

const sendFormDataToNetlifyAndRedirect = ({
  'form-name': formName,
  ...rest
}: FormData) => {
  const requestBody = netlifyFormsEncode({ 'form-name': formName, ...rest })
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: requestBody,
  }

  fetch('/', requestOptions).then(() => navigate('/submission'))
}

function ContactPageContactForm() {
  const formik = useFormikContext<FormData>()
  return <PureContactForm formik={formik} content={contactContent} />
}

function ContactForm({ formName }: ContactFormProps): Node {
  const initialValues: FormData = {
    'form-name': formName,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
    hasOptedIn: true,
    botField: '',
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={sendFormDataToNetlifyAndRedirect}
      validationSchema={ContactSchema}
    >
      <ContactPageContactForm />
    </Formik>
  )
}

export default ContactForm
